/**
 * Helper functions for managing product variants
 */

/**
 * Get select element by option number
 */
export function getSelect(scope, n) {
    return (
        scope.querySelector(`.change--selectProduct[data-index="option${n}"]`) ||
        scope.querySelector(`#option-${n}__select--item`)
    );
}

/**
 * Pick variant based on selected options
 */
export function pickVariant(variantsSelect, v1, v2, v3) {
    let opts = Array.from(variantsSelect.options);
    if (v1) opts = opts.filter(o => o.dataset.option1 === v1);
    if (v2) opts = opts.filter(o => o.dataset.option2 === v2);
    if (v3) opts = opts.filter(o => o.dataset.option3 === v3);
    return opts.find(o => o.dataset.available === 'true') || opts[0] || null;
}

/**
 * Sync variant selection and update UI
 */
export function syncVariant(scope) {
    const variantsSelect = scope.querySelector('.product-single__variants');
    if (!variantsSelect) return;

    const s1 = getSelect(scope, 1);
    const s2 = getSelect(scope, 2);
    const s3 = getSelect(scope, 3);

    const v1 = s1 ? s1.value : '';
    const v2 = s2 ? s2.value : '';
    const v3 = s3 ? s3.value : '';

    let opt = pickVariant(variantsSelect, v1, v2, v3);
    if (!opt) return;

    const id = opt.value;
    const price = opt.getAttribute('data-price') || '';
    const comparePrice = opt.getAttribute('data-compare-price') || '';
    const available = opt.getAttribute('data-available');
    const dataImgID = opt.getAttribute('data-image-id');
    const imgFixed = opt.getAttribute('data-image-fixed');

    // Update variant select
    variantsSelect.value = id;
    Array.from(variantsSelect.options).forEach(o => (o.selected = o.value === id));
    variantsSelect.dispatchEvent(new Event('change', { bubbles: true }));
    variantsSelect.dispatchEvent(new Event('input', { bubbles: true }));

    // Update price
    const priceNode = scope.querySelector('.js--price--main');
    const compareNode = scope.querySelector('.js--compare-price--main');
    if (priceNode) priceNode.innerHTML = price;
    if (compareNode) {
        if (comparePrice) {
            compareNode.innerHTML = comparePrice;
            compareNode.style.display = '';
        } else {
            compareNode.style.display = 'none';
        }
    }

    // Update buttons
    document.querySelectorAll('.js--sumbit__button, .js--sumbit').forEach(btn => {
        btn.disabled = available === 'false';
    });

    const addBtn = document.getElementById('AddToCartCustom');
    if (addBtn) addBtn.dataset.startingVariant = id;
    window.selectedVariantId = parseInt(id, 10);

    // Update URL
    const newurl = `${location.protocol}//${location.host}${location.pathname}?variant=${id}`;
    history.replaceState({ path: newurl }, '', newurl);

    // Update fixed image
    if (imgFixed) {
        const fixed = scope.querySelector('.js__fixed__img');
        if (fixed) fixed.innerHTML = `<img src="${imgFixed}" alt="" class="fixed__image__product">`;
    }

    // Update gallery position
    if (dataImgID) {
        const mobItem = document.querySelector(`.js__item__show--img[data-image-id="${dataImgID}"]`);
        const count = mobItem ? parseInt(mobItem.getAttribute('data-count') || '0', 10) : 0;

        if (typeof window.mainSlider !== 'undefined' && count) {
            window.mainSlider.slideTo(count);
        }

        const imgProduct = document.querySelector(`.img--main__product[data-image-id="${dataImgID}"]`);
        if (imgProduct) {
            const targetY = imgProduct.offsetTop - 106;
            window.scrollTo({ top: targetY, behavior: 'smooth' });
        }
    }

    return id;
}
